<template>
    <div>
        <div class="row justify-content-end pr-3 ml-1 ml-md-0 pb-4 pb-lg-0"
            v-if="displayBookingSummary">
            <div v-bind:class="['col-12 col-lg-11 container--grey rounded--2 pt-4 pb-4 summary']">
                <h6 class="font-weight-bold" v-html="TEXTS.render(`BOOKING_SUMMARY_HEADER`)"></h6>
                <hr class="d-block mt-2 summary-title-separator" align="left">
                <!-- <div class="row pl-3 pr-3 mb-3">
                    <div class="col-12">
                        <div class="row border rounded pt-2 pb-2 summary--section">
                            <div class="col-12 col-md-5 border-right">
                                <div class="d-inline-block d-md-flex justify-content-center">
                                    <strong>14</strong>
                                    &nbsp;April 2019
                                </div>
                                <div class="d-inline-block d-md-block text-center">
                                    to
                                </div>
                                <div class="d-inline-block d-md-flex justify-content-center">
                                    <strong>18</strong>
                                    &nbsp;April 2019
                                </div>
                            </div>
                            <div class="col-12 col-md-7">
                                <div class="row">
                                    <div class="col-2 pl-md-1 pr-3 pr-md-0">
                                        <i aria-hidden="true" class="icon icon-pin float-right"></i>
                                    </div>
                                    <div class="col-10 pl-md-1">
                                        <small class="font-weight-bold">11 Sanstone Court Delahey 3037</small>
                                    </div>
                                </div>
                                <div class="pl-md-5 pl-lg-2">Bulk Bin Service</div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <booking-summary-section-one />
                <!-- <div class="row pl-3 pr-3 mb-3">
                    <div class="col-12">
                        <div class="row border rounded pt-2 pb-2 summary--section">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-8"><small>(1) Hardwaste</small></div>
                                    <div class="col-4 text-right font-weight-bold">$45.50</div>
                                </div>
                                <div class="row">
                                    <div class="col-8"><small>(1) Mattress and base (1 set only)</small></div>
                                    <div class="col-4 text-right font-weight-bold">$32.18</div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-8"><small>Subtotal</small></div>
                                    <div class="col-4 text-right font-weight-bold">$77.68</div>
                                </div>
                                <div class="row">
                                    <div class="col-8"><small>GST</small></div>
                                    <div class="col-4 text-right font-weight-bold">$5.00</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <booking-summary-section-two :allPriceList="allPrices" />
                <!-- <div class="row pl-3 pr-3">
                    <div class="col-12">
                        <div class="row border rounded pt-2 pb-2 summary--section">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-8 text-uppercase"><small class="font-weight-bold">total amount</small></div>
                                    <div class="col-4 text-right font-weight-bold">$82.68</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <booking-summary-section-three ref="summarySectionThree"/>
            </div>
        </div>
    </div>
</template>

<script>
    import BookingSummarySectionOne from './BookingSummarySectionOne';
    import BookingSummarySectionTwo from './BookingSummarySectionTwo';
    import BookingSummarySectionThree from './BookingSummarySectionThree';
    import Texts from '../../../../common/utils/Texts';
    import ServicePrices from '../../../../common/utils/ServicePrices';
    import Helper from '../../../../helper'
    
    export default {
        props: {
            allPrices: Array
        },
        components: {
            BookingSummarySectionOne,
            BookingSummarySectionTwo,
            BookingSummarySectionThree
        },
        data() {
            return {
                displayBookingSummary: false
            }
        },
        mounted() {
            this.$store.dispatch('getDefaultData');
        },
        computed: {
            TEXTS: ()=> Texts,
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE;
            },
            selectedService(){
                return this.bookingState ? this.bookingState.selectedService : null
            },
            selectedServicePaymentType(){
                return this.bookingState && this.bookingState.selectedService ? this.bookingState.selectedService.is_paid : null 
            },
            multipleCollectionSettingsOfService(){
                return this.$store.getters.GET_ACTIVE_MULTIPLE_COLLECTION_SETTING;
            },
            sectionThreeHasError(){
                var summarySectionThree = this.$refs.summarySectionThree
                return summarySectionThree ? summarySectionThree.isDisplayError : false
            }
        },
        watch: {
            'allPrices': function(val) {
                if (val && val.length > 0) {
                    const servicePrices = new ServicePrices();
                    servicePrices.setServices(val);
                }
            },
            selectedService(){
                this.determineDisplayOfBookingSummary()
            },
            multipleCollectionSettingsOfService(){
                this.determineDisplayOfBookingSummary()
            }
        },
        methods: {
            determineDisplayOfBookingSummary() {
                var displayBookingSummary = false
                var { selectedServicePaymentType, multipleCollectionSettingsOfService } = this
                if(selectedServicePaymentType == Helper.Payment.Paid){
                    displayBookingSummary = true
                }
                else if(selectedServicePaymentType == Helper.Payment.Free 
                && multipleCollectionSettingsOfService 
                && multipleCollectionSettingsOfService.selection == 2 
                && multipleCollectionSettingsOfService.per_waste_summary == 1){
                    displayBookingSummary = true
                }

                if (this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
                    displayBookingSummary = true;
                }

                this.displayBookingSummary = displayBookingSummary
            }
        },
    }
</script>